import { Injectable, signal } from '@angular/core';
import { PortalSettings } from '../../models';

const SETTINGS_KEY = 'portal_settings';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  settings = signal<PortalSettings | null>(null);

  constructor() {
    this.applySettingsFromStorage();
  }

  applySettingsFromStorage(): void {
    try {
      const settingsStr = localStorage.getItem(SETTINGS_KEY);
      if (settingsStr && settingsStr !== 'undefined') {
        const settings = JSON.parse(settingsStr);
        this.applySettings(settings);
      } else {
        this.clearSettings();
      }
    } catch (e) {
      console.error("Failed to parse portal settings from storage", e);
      this.clearSettings();
    }
  }

  applySettings(settings: PortalSettings | null): void {
    this.settings.set(settings);
    if (settings) {
      this.setCssVariable('--portal-primary-color', settings.primaryColor);
      this.setCssVariable('--portal-accent-color', settings.accentColor ?? null);
      this.setCssVariable('--portal-bg-color', settings.backgroundColor ?? null);
      this.setCssVariable('--portal-card-color', settings.cardColor ?? null);
      this.setCssVariable('--portal-text-color', settings.textColor ?? null);
    } else {
      this.clearSettings();
    }
  }
  
  clearSettings(): void {
    this.settings.set(null);
    this.setCssVariable('--portal-primary-color', null);
    this.setCssVariable('--portal-accent-color', null);
    this.setCssVariable('--portal-bg-color', null);
    this.setCssVariable('--portal-card-color', null);
    this.setCssVariable('--portal-text-color', null);
  }

  private setCssVariable(name: string, value: string | null): void {
    if (typeof document !== 'undefined') {
      if (value) {
        document.documentElement.style.setProperty(name, value);
      } else {
        document.documentElement.style.removeProperty(name);
      }
    }
  }
}